
import {
  defineComponent, reactive, watch,
} from 'vue';
import Icone from '@/core/components/Icone.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import { useModalBase } from '@/core/composables/ModalBase';
import { ICteDocumentoReferenciado } from '@/models/Entidades/Compras/ConhecimentoTransporte/ICteDocumentoReferenciado';

function criarDocumentoVazio(): ICteDocumentoReferenciado {
  return {
    codigo: 0,
    codigoCte: 0,
    chaveAcessoDocumento: '',
    codigoNotaFiscalEntrada: 0,
    valorDocumento: 0,
    valorFretePorDocumento: 0,
    pesoDocumento: 0,
  };
}

export default defineComponent({
  name: 'CteDocumentoReferenciadoModal',
  components: {
    Icone,
    CampoNumerico,
  },
  props: {
    visivel: {
      type: Boolean,
      required: true,
    },
    documento: {
      type: Object as () => ICteDocumentoReferenciado | null,
      default: null,
    },
    indexEdicao: {
      type: Number,
      default: -1,
    },
  },
  emits: ['update:visivel', 'confirmar'],
  setup(props, { emit }) {
    const { modalBase } = useModalBase(props, emit);

    const state = reactive({
      documento: criarDocumentoVazio(),
      indexEdicao: -1,
      erroChave: '',
      erroValor: '',
    });

    watch(() => props.visivel, (visivel) => {
      if (visivel) {
        state.erroChave = '';
        state.erroValor = '';
        state.indexEdicao = props.indexEdicao;
        if (props.documento) {
          state.documento = {
            codigo: props.documento.codigo ?? 0,
            codigoCte: props.documento.codigoCte ?? 0,
            chaveAcessoDocumento: (
              props.documento.chaveAcessoDocumento
              ?? (props.documento as any).chaveAcesso
              ?? (props.documento as any).ChaveAcessoDocumento
              ?? (props.documento as any).chaveAcessoDoc
              ?? ''
            ).toString(),
            tipoDocumento: props.documento.tipoDocumento,
            numeroDocumento: props.documento.numeroDocumento,
            serie: props.documento.serie,
            dataEmissao: props.documento.dataEmissao,
            codigoNotaFiscalEntrada: props.documento.codigoNotaFiscalEntrada ?? 0,
            valorDocumento: props.documento.valorDocumento ?? 0,
            valorFretePorDocumento: props.documento.valorFretePorDocumento ?? 0,
            pesoDocumento: props.documento.pesoDocumento ?? 0,
          };
        } else {
          state.documento = criarDocumentoVazio();
        }
      }
    });

    function tratarCola(event: ClipboardEvent) {
      const texto = event.clipboardData?.getData('text') ?? '';
      const limpo = texto.replace(/\D/g, '').substring(0, 44);
      event.preventDefault();
      state.documento.chaveAcessoDocumento = limpo;
    }

    function validar(): boolean {
      state.erroChave = '';
      state.erroValor = '';
      let valido = true;

      const chave = state.documento.chaveAcessoDocumento?.trim() ?? '';
      if (chave.length === 0) {
        state.erroChave = 'A chave de acesso é obrigatória.';
        valido = false;
      } else if (chave.length !== 44) {
        state.erroChave = `A chave deve ter 44 dígitos. Atual: ${chave.length}.`;
        valido = false;
      }

      if (state.documento.valorDocumento <= 0) {
        state.erroValor = 'Informe um valor maior que zero.';
        valido = false;
      }

      return valido;
    }

    function confirmar() {
      if (!validar()) return;
      emit('confirmar', { ...state.documento }, state.indexEdicao);
      modalBase.computedVisivel = false;
    }

    return {
      props,
      state,
      modalBase,
      tratarCola,
      confirmar,
    };
  },
});
